export default __webpack_public_path__ + "static/media/free-shipping.93d0d5fd.png";